export const BEFORE_LOGIN_CTA = `על מנת לצפות בנתונים של עיר זו, יש להכנס למערכת`;
export const NOT_ENOUGH_DATA_TEXT = `אין לנו מספיק נתונים עבור אזור זה בתקופה הנבחרת\nניתן תמיד לצפות בנתוני האיזור הכללים`;
export const NOT_ENOUGH_DATA_BUTTON_CTA = `לצפייה בנתונים`;
export const NOT_ENOUGH_DATA_FOR_CITY_TEXT =
  "אין לנו מספיק נתונים עבור אזור זה בתקופה הנבחרת";
